import { atom } from "recoil";

const bookmarksAtom = atom({
    key: 'bookmarks',
    default: null
})

export default bookmarksAtom